<template>
  <div style="width: 100%; text-align: center">
    <v-menu v-if="inPopup && !isHideButtonRow" open-on-hover close-on-click close-on-content-click left offset-x>
      <template v-slot:activator="{ on }">
        <v-btn class="ag-grid-button" v-on="on" elevation="0" fab small>
          <v-icon>mdi mdi-dots-horizontal</v-icon>
        </v-btn>
      </template>
      <v-card class="pa-3">
        <ButtonCellContent
          @buttonClicked="onClick($event)"
          :rowIndex="params.rowIndex"
          :row="params.data"
          :rows="params.frameworkComponentWrapper.parent.rowData"
          :buttons="buttonsFormat"
        />
      </v-card>
    </v-menu>
    <ButtonCellContent class="ag-grid-button" v-else @buttonClicked="onClick($event)" :buttons="buttonsFormat" />
  </div>
</template>

<script>
/**
 -id
 -color
 -dark
 -icon
 -title
 */
import ButtonCellContent from './ButtonCellContent'
import { getVisibilityButton } from './getVisibilityButton'

export default {
  name: 'ButtonCellRenderer',
  components: {
    ButtonCellContent
  },
  data: () => ({
    menu: false
  }),
  beforeMount() {},
  methods: {
    onClick(button) {
      this.params.frameworkComponentWrapper.parent.$emit('gridButtonClicked', {
        id: button.id,
        data: this.params.data,
        OnClickAction: button.OnClickAction && Object.keys(button.OnClickAction).length !== 0 ? button.OnClickAction : undefined
      })
    }
  },
  computed: {
    isHideButtonRow() {
      let buttonsToHide = 0
      
      // вычисляем видимость всех кнопок в строке
      for (let buttonIndex = 0; buttonIndex < this.buttonsFormat.length; buttonIndex++) {
        const currentButton = this.buttonsFormat[buttonIndex]
        const isCurrentButtonVisible = getVisibilityButton(
          currentButton,
          this.params.data, //row
          this.params.rowIndex, //rowIndex
          this.params.frameworkComponentWrapper.parent.rowData //rows
        )


        if (currentButton?.visibilityExpression && !isCurrentButtonVisible) {
          buttonsToHide += 1
        }
      }
      // Если кнопок которые должны быть скрыты столько же как и кнопок всего
      if (buttonsToHide === this.buttonsFormat.length) {
        return true
      }

      return false
    },
    buttonsFormat() {
      //Получить кнопки в старом или новом формате
      return this.params.colDef.buttonsList || this.params.value
    },
    inPopup() {
      return this.params.colDef.inPopup
    }
  }
}
</script>

<style lang="scss">
.ag-row-hover {
  .ag-grid-button {
    opacity: 1;
  }
}
.ag-grid-button {
  transition: 0.3s;
  opacity: 0.4;
}
</style>
